import { App } from "vue";

const TextSlicePlugin = {
  install: (app: App) => {
    app.config.globalProperties.$textslice = (text: string, count: number) => {
      if (!text || text.length <= count) return text;
      return text.slice(0, count) + "...";
    };
  },
};

export default TextSlicePlugin;
